import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import GetIcon from "../../../../utils/Icon";

const TableTab1 = ({
  selected_default_item_attribulte_data = [],
  setselected_default_item_attribulte_data = () => {},
}) => {
  // ✅ Safe initialization (always an array)
  const [rows, setRows] = useState(
    Array.isArray(selected_default_item_attribulte_data)
      ? selected_default_item_attribulte_data
      : []
  );

  const createNewRow = () => ({
    attribute_value: "",
    abbr: "",
  });

  const tableRef = useRef();
  const [rowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });

  // ✅ Keep rows synced with parent data
  useEffect(() => {
    if (Array.isArray(selected_default_item_attribulte_data)) {
      setRows(selected_default_item_attribulte_data);
    }
  }, [selected_default_item_attribulte_data]);

  // ✅ Derived values
  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allRowIndices = rows.map((_, index) => index);
      setSelectedRows(allRowIndices);
    } else {
      setSelectedRows([]);
    }
  };

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const updateRow = (index, field, value) => {
    const updatedRows = [...rows];
    const row = { ...updatedRows[index] };

    if (row.item && field in row.item) {
      row.item = { ...row.item, [field]: value };
    } else {
      row[field] = value;
    }

    updatedRows[index] = row;
    setRows(updatedRows);
    setselected_default_item_attribulte_data(updatedRows);
  };

  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setRows(newRows);
    setselected_default_item_attribulte_data(newRows);
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    if (currentPage !== lastPage) setCurrentPage(lastPage);
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows(updatedRows);
    setselected_default_item_attribulte_data(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) setCurrentPage(lastPage);
  };

  // ✅ Column resize logic
  useEffect(() => {
    const cols = tableRef.current?.querySelectorAll("th") || [];
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  return (
    <div className="">
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {[
              "Action",
              "S.No",
              "Attribute Value",
              "Abbreviation",
              <GetIcon iconName="PiSlidersHorizontalBold" size={12} key="icon" />,
            ].map((title, i) => {
              const isIcon = typeof title !== "string";
              const defaultWidths = {
                Action: "54px",
                "S.No": "54px",
                "Attribute Value": "303px",
                "Abbreviation": "303px",
              };

              
            })}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            return (
              <tr key={globalIndex}>
                

                <td style={{ textAlign: "center", fontSize: "0.8rem" }}>
                  {globalIndex + 1}
                </td>

                {/* Attribute Value */}
                <td
                  className="p-0 d-flex justify-content-center"
                  style={{
                    border:
                      focusedCell.rowIndex === globalIndex &&
                      focusedCell.field === "attribute_value"
                        ? "0.3px solid #270b79"
                        : "",
                  }}
                >
                  <input
                    type="text"
                    className="form-control tableinput noborder"
                    style={{ fontSize: "0.8rem", textAlign: "center" }}
                    value={
                      row?.item?.attribute_value ??
                      row?.attribute_value ??
                      ""
                    }
                    readOnly
                    placeholder="Attribute Value"
                    onFocus={() =>
                      setFocusedCell({
                        rowIndex: globalIndex,
                        field: "attribute_value",
                      })
                    }
                    onBlur={() =>
                      setFocusedCell({ rowIndex: null, field: null })
                    }
                    onChange={(e) =>
                      updateRow(globalIndex, "attribute_value", e.target.value)
                    }
                  />
                </td>

                {/* Abbreviation */}
                <td
                  className="p-0"
                  style={{
                    border:
                      focusedCell.rowIndex === globalIndex &&
                      focusedCell.field === "abbr"
                        ? "0.3px solid #270b79"
                        : "",
                  }}
                >
                  <input
                    type="text"
                    className="form-control tableinput noborder"
                    style={{ fontSize: "0.8rem", textAlign: "center" }}
                    value={row?.item?.abbr ?? row?.abbr ?? ""}
                    placeholder="Abbreviation"
                    onFocus={() =>
                      setFocusedCell({ rowIndex: globalIndex, field: "abbr" })
                    }
                    onBlur={() =>
                      setFocusedCell({ rowIndex: null, field: null })
                    }
                    onChange={(e) =>
                      updateRow(globalIndex, "abbr", e.target.value)
                    }
                    readOnly
                  />
                </td>

              
              </tr>
            );
          })}
        </tbody>
      </table>

     <div
        className="d-flex pb-2  justify-content-between align-items-center"
        style={{ marginTop: "12px", marginBottom: "16px" }}
      >
        <div
          className={`${
            rows.length < 11 ? "d-none" : "d-flex"
          } align-items-center centerpagination`}
          style={{ gap: "5px" }}
        >
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={rows.length}
          />
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: "12px", color: "#270B79" }}>
            Showing {indexOfFirstRow + 1} to{" "}
            {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
          </span>
        </div>
      </div>
    </div>
  );
};

export default TableTab1;
